import React, { useState } from "react";
import {
  Grid,
  GridCellProps,
  GridColumn as Column,
  GridItemChangeEvent,
  GridPageChangeEvent,
  GridPagerSettings,
  GridRowProps,
  GridNoRecords
} from "@progress/kendo-react-grid";
import { SortDescriptor } from "@progress/kendo-data-query";
import { Link } from "react-router-dom";
import { Icon } from "@iconify/react";
import { DropDown } from "./myDropDown";
import "./tablestyle.scss";
import PopupMenu from "../popupmenu";
import { useAppDispatch, useAppSelector } from "../../hooks/redux-hooks";
import { storeSelectedRow } from '../../store/timeSheetSelectedRow/timeSheetSelectedSlice';
import stroke from "../../assets/images/stroke.png"


function CandidateTimesheet(Props: any) {

  const initialSort: Array<SortDescriptor> = [{ field: "", dir: "asc" }]

  const [sort, setSort] = useState(initialSort)
  const dispatch = useAppDispatch();


  const rowClick = (e: any) => {
    Props.rowClick(e);
  }

  const checkStatus = (status: string) => {
    switch (status) {
      case '1':
        return {
          value: 'Draft',
          class: 'statusMessage Gray'
        }
      case '2':
        return {
          value: 'Submitted',
          class: 'statusMessage Yellow'
        }
      case '3':
        return {
          value: 'Approved',
          class: 'statusMessage Green'
        }
      case '4':
        return {
          value: 'Rejected',
          class: 'statusMessage Red'
      }
      default:
        return {
          value: '',
          class: ''
      }
    }
  }

  const getTableValues = () => {
    Props.getTables()
  }
  const openInNewTab = (url: any) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };
  const buttonClick = (data: any) => {
    // if (data.timesheetStatus === '1') {
    //     Props.sendReminder(data)
    // }
    // else
    // {
    localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(data))
    openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
  //  }
  }

  const viewButton = (props: GridCellProps) => {   
    
    const handleChange = (data: any) => {   
      switch (data.target.text) {
        case 'Upload':
          localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(props.dataItem))
          openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
          return
        case 'Send Reminder':
          Props.sendReminder(props.dataItem)
          return
        case 'View':
          localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(props.dataItem))
          openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
          return
        case 'Edit':
          localStorage.setItem('CandidateTimesheetSettings', JSON.stringify(props.dataItem))
          openInNewTab(`${window.location.origin}/candidatetimesheetsettings`)
      }
    }
    
    return (
      <td>
        {props.dataItem.timesheetStatus !== '3' ?
          // <DropDownList data={props.dataItem.timesheetStatus === '1' ? dropDownValues1 : dropDownValues2} onChange={handleChange} />
          <PopupMenu>
            <div className='popupLinks'>
              <Link to='' onClick={handleChange}>{props.dataItem.timesheetStatus === '1' ? 'Upload' : 'View' }</Link>
              <Link to='' onClick={handleChange}>{props.dataItem.timesheetStatus === '1' || props.dataItem.timesheetStatus === '2'  ? 'Send Reminder' : 'Edit' }</Link>
            </div>
          </PopupMenu>
          : 
        <div style={{ 'color': '#14A800'}} className="cursor"  onClick={() => buttonClick(props.dataItem)}>View</div>
        }
        {/* <div style={{ 'color': '#14A800'}}  onClick={() => buttonClick(props.dataItem)}>{props.dataItem.timesheetStatus === '1' ? 'Send Reminder' : 'View'}</div>          */}
      </td>
    );
  };

  const durationCell = (props: GridCellProps) => {
    return (
      <td>
        {props.dataItem.startDate && new Date(parseInt(props.dataItem.startDate)).toDateString().slice(3) + " - " + new Date(parseInt(props.dataItem.endDate)).toDateString().slice(3)}
      </td>
    )
  }

  const historyCell = (props: GridCellProps) => {
    return (
        <td>
            <Link to={''} onClick={() => Props.showHistory(props.dataItem)}><Icon icon="bx:history"width="25" style={{'color':'rgba(0, 0, 0, 0.6)'}} ></Icon></Link>
        </td>
    )
  }

  const statusCell = (props: GridCellProps) => {
  
    return (
        <td>
            <div className={checkStatus(props.dataItem.timesheetStatus).class}>
           {checkStatus(props.dataItem.timesheetStatus).value}
        </div>
        </td>
    )
  }

  const timeSheetSelectedRow = useAppSelector(state => state.timeSheetSelectedRow);

  const nameCell = (props: GridCellProps, redirection: any) => {
  
    let currentDate = new Date().getTime()
    let dateOfRegistration = props.dataItem.createdOn
    var diff =(currentDate -  dateOfRegistration) / 1000;
    diff /= (60 * 60);
    let diff2 = Math.abs(Math.round(diff));
    
    const profileImage = props.dataItem.googleProfileImage ?  props.dataItem.googleProfileImage : " " 
    let name = props.dataItem.candidateName.split(" ")
    let lastName = name[1]

    const selectedRow = (timesheetDetails: any) => {
      let seletedData: any = [...timeSheetSelectedRow];
      seletedData.some((data: any) => {
        return data.timesheetId !== timesheetDetails.timesheetId
      }
      );
      if (seletedData.some((data: any) => data.timesheetId === timesheetDetails.timesheetId)) {
        let newdata: any = seletedData.filter((f: any) => f.timesheetId !== timesheetDetails.timesheetId)
        dispatch(storeSelectedRow(newdata))
      }
      else {
        let newdata = [...seletedData, timesheetDetails];
        dispatch(storeSelectedRow(newdata))
      }

    }
 
    return (
      <td className="statusWrap">
      {diff2 <= 24 &&
        <span className="userStatus">New</span>
      }
      <div className="userInfo" onClick={() => selectedRow(props.dataItem)}>
        <div className="stroke-wrapper"> 
        {timeSheetSelectedRow.map((data: any) => {

          if (data.timesheetId == props.dataItem.timesheetId) {
            return (<img className="strokeimg" src={stroke} />);
          }
          })
          }
  
          {profileImage === " "? 
           <figure onClick={() => selectedRow(props.dataItem)}>{ checkInArray(props.dataItem.timesheetId) ? '': `${props.dataItem && props.dataItem.candidateName && props.dataItem.candidateName[0]}${lastName[0]}`}</figure>
          :
          <figure onClick={() => selectedRow(props.dataItem)}><img src={ profileImage }></img></figure> 
          }
          </div>
          <div onClick={() => redirection(props.dataItem.loginId)}>
          {props.dataItem.candidateName}
          <div className="email">{props.dataItem.email}</div>
          <div className="phone">{props.dataItem.phoneNumber}</div>
          </div>
      </div>
    </td>
    )
  }

  const checkInArray = ( value: any) => {
    // let array1: string[] = []
     let array1 = timeSheetSelectedRow
     let decision = false
     array1.map((item: any) => {
      if(item.timesheetId === value)
          decision = true
     })
     return decision
  }
  
  return (
    <>
      <Grid
          data={Props.state.items}
          onPageChange={Props.pageChange}
          total={Props.state.total}
          skip={Props.state.skip}
          pageable={Props.state.pageable}
          pageSize={Props.state.pageSize}
          onItemChange={Props.itemChange}
          sortable={true}
          sort={sort}
          onRowClick={(e) => rowClick(e)}
          onSortChange={(e) => {
          setSort(e.sort);
          Props.setSort(e.sort);
          Props.applySort(e.sort);
            }}
      
      >
        <GridNoRecords>
          <div className="noData">
            <Icon icon="mdi:smiley-neutral-outline" />
            No data to display
          </div>
        </GridNoRecords>
        <Column  title="Name" cell={nameCell}  width="180px"/>
        <Column field="duration" title="Duration" cell={durationCell} />
        <Column field="position" title="JobRole" />
        <Column field="companyName" title="Company"  />
        <Column field="actualWorkingDays" title="Actual working days"  cell={actualWorkingDaysCell}/>
        <Column field="leaves" title="Leaves" cell={leaveCell}  width="65px"/>
        <Column field="Submitted on" title="Submitted on" cell={submittedCell}/>
        <Column field="status" title="Status" cell={statusCell} width="70px"/>
        <Column field="verifiedBy" title="Verified by"  className="wordBreak"/>
        <Column field="invoiceRaisedStatus" title="Invoice raised"  cell={(props: GridCellProps) => DropDown(props, () => getTableValues())}/>
        <Column cell={historyCell} width="50px"/>
        <Column cell={viewButton} />
      </Grid>
     </>
  );
}

export default CandidateTimesheet;



const actualWorkingDaysCell = (props: GridCellProps) => {
  return (
    <td>
      {props.dataItem.actualWorkingDays}
    </td>
  )
}

const leaveCell = (props: GridCellProps) => {
  return (
    <td>
      {props.dataItem.leaves}
    </td>
  )
}

const submittedCell = (props: GridCellProps) => {
  return (
    <td>
      {props.dataItem.submittedOn && new Date(parseInt(props.dataItem.submittedOn)).toDateString().slice(3)}
    </td>
  )
}

const invoiceRaisedCell = (props: GridCellProps) => {
  return (
    <td>
      {props.dataItem.invoiceRaisedDate}
    </td>
  )
}

// const statusCell = (props: GridCellProps) => {
  
//   return (
//     <td>
//       {props.dataItem.status}
//     </td>
//   )
// }